module.exports = __webpack_public_path__ + "media/images/city/048-blue-domed-church-a4740248822210614e646687ea55f31a.svg";